import { ALGOLIA_FETCH, ALGOLIA_FETCH_SUCCESS, ALGOLIA_FETCH_FAILURE } from "../actionTypes";

const INITIAL_STATE = {
  api_id: "",
  api_key: "",
  calls_index: "",
  loading: false,
  error: null,
};

const algoliaReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ALGOLIA_FETCH:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case ALGOLIA_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        ...action.payload,
      };
    case ALGOLIA_FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default algoliaReducer;
